import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 获取工单列表
 */
export function getMaintainOrderPlanList(data) {
  return fetch ({
    url: '/maintain/manage/maintain/order/orderPlanList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 编辑单位
 */
export function editUnit(data) {
  return fetch({
    url: '/auth/unit/edit',
    method: 'POST',
    data
  })
}


/**
 * @param {idList[]} data
 * 删除工单
 */
export function deleteOrderPlan(data) {
  return fetch({
    url: '/maintain/manage/maintain/order/orderPlanDelete',
    method: 'POST',
    data
  })
}


/**
 * @param {id} params
 * 导出PDF
 */
export function exportPDF(params) {
  return formAxios({
    url: '/maintain/manage/maintain/order/exportPdf',
    method: 'GET',
    params
  })
}



/**
 * @param {} 
 * 导出EXAIL
 */
export function exportEXAIL() {
  return formAxios({
    url: '/maintain/manage/maintain/order/exportTemplateList',
    method: 'GET',
  })
}


/**
 * @param {Object} data
 * 获取部门列表
 */
export function getDepartmentTree(params) {
  return fetch ({
    url: '/auth/department/getDepartmentTree',
    method: 'GET',
    params
  })
}


/**
 * @param {orderId} params
 * 根据部门id获取工单详情
 */
export function getOrderDetailInfo(params) {
  return fetch({
    url: '/maintain/manage/maintain/order/getOrderDetailInfo',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 根据unitId和部门id获取项目
 */
export function getProjectLiftTree(params) {
  return fetch({
    url: '/maintain/project/projectLiftTree',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} params
 * 根据部门id获取部门详情
 */
export function getDepartmentDetail(params) {
  return fetch({
    url: '/auth/department/detail',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 获取项目
 */
export function getProjectSimpleList(data) {
  return fetch ({
    url: '/maintain/project/simpleList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 获取使用单位列表
 */
export function getPropertyUnitSimpleList(data) {
  return fetch ({
    url: '/auth/subPlatform/propertyUnit/simpleList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 获取电梯列表
 */
export function getLiftSimpleList(data) {
  return fetch ({
    url: '/maintain/lift/simpleList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 维保类型列表
 */
export function getMaintainTypeList(data) {
  return fetch ({
    url: '/maintain/maintain/item/maintainTypeList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 维保计划保存
 */
export function orderPlanSave(data) {
  return fetch ({
    url: '/maintain/manage/maintain/order/orderPlanSave',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 维保计划详情
 */
export function orderPlanDetail(params) {
  return fetch ({
    url: '/maintain/manage/maintain/order/orderPlanDetail',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 用户下拉框
 */
export function getUserSimpleList(data) {
  return fetch ({
    url: '/auth/subPlatform/user/simpleList',
    method: 'POST',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/MaintenancePlan/index.js